module.exports = __webpack_public_path__ + "img/sac-pt-BR.40b07f48.png";